import React, { useContext, memo, useCallback } from "react";
import ResourceHeader from "./ResourceHeader";
import WeekView from "./WeekView";
import MonthView from "./MonthView";
import DayView from "./DayView";
import HourlyView from "./HourlyView";
import { ResourcePlannerContext } from "../ResourcePlannerContext";
import Spin from "../../../../components/controls/spinner/Spin";
import Styles from "../ResourceMonitor.module.scss";
import NotFoundLayout from "../../../../components/controls/NotFound/NotFound";
import { NotFoundIcon } from "../../../../modules/default-svg";

const ResourceMoniteringMain = memo(({
  formBody,
  dashboard,
  clickHandler,
  displayType,
}) => {
  const { setTabView, tabView, isCalendarLoading, calendarData } = useContext(
    ResourcePlannerContext
  );

  const handleCalendarsView = useCallback((view) => {
    setTabView(view.toLowerCase());
  }, [setTabView]);

  // Memoize container height calculation
  const containerHeight = displayType === "resources" 
    ? "calc(100vh - 209px)" 
    : "calc(100vh - 530px)";

  return (
    <React.Fragment>
      <ResourceHeader
        handleCalendarsView={handleCalendarsView}
        buttonStatus={tabView}
        dashboard={dashboard}
        clickHandler={clickHandler}
      />
      {isCalendarLoading ? (
        <div
          className={Styles.spinnerContainer}
          style={{
            height: containerHeight,
            maxHeight: containerHeight,
            minHeight: containerHeight,
          }}
        >
          <Spin />
        </div>
      ) : calendarData.length > 0 ? (
        <div
          style={{
            zIndex: 0,
            height: displayType === "resources" ? containerHeight : "",
          }}
        >
          {tabView === "month" && (
            <MonthView formBody={formBody} dashboard={dashboard} />
          )}
          {tabView === "week" && (
            <WeekView formBody={formBody} dashboard={dashboard} />
          )}
          {tabView === "day" && (
            <DayView formBody={formBody} dashboard={dashboard} />
          )}
          {/* {tabView === "hour" && (
            <HourlyView formBody={formBody} dashboard={dashboard} />
          )} */}
        </div>
      ) : (
        <div
          className={Styles.spinnerContainer}
          style={{
            height: containerHeight,
            minHeight: containerHeight,
          }}
        >
          <NotFoundLayout
            icon={<NotFoundIcon />}
            heading="No data currently available!"
            para=""
          />
        </div>
      )}
    </React.Fragment>
  );
});

ResourceMoniteringMain.displayName = 'ResourceMoniteringMain';

export default ResourceMoniteringMain;
